export default __webpack_public_path__ + "static/media/generalChecks.0dac1050.png";